import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrganisationService } from './services/organisation.service';
@Injectable()
export class httpInterceptor implements HttpInterceptor {
  private organisationService = inject(OrganisationService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const orgHeader = this.organisationService.activeOrgId()
      ? ({
          'X-Finxone-Org-Id': this.organisationService.activeOrgId(),
        } as { [header: string]: string })
      : {};

    // Never label a multipart upload as JSON. Only the browser can write the
    // multipart Content-Type, because only it knows the boundary — overriding it
    // makes the server's JSON parser choke on the body ("Unexpected token '-'").
    // Detecting FormData covers every upload; a url allowlist only covered the
    // one that existed when it was written.
    const isMultipart = req.body instanceof FormData;
    req = req.clone({
      setHeaders: {
        ...orgHeader,
        Accept: '*/*',
        ...(isMultipart ? {} : { 'Content-Type': 'application/json' }),
      },
    });
    return next.handle(req);
  }
}
